import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
const InvestigationLoadingSkeleton = () => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-1"><Shimmer className="hidden md:block rounded-md" height={28} width={28} /><Shimmer className="rounded-md max-md:size-11!" height={28} width={28} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="min-w-0 flex-1 md:flex-none md:absolute md:left-1/2 md:-translate-x-1/2"><Shimmer className="rounded-md max-w-full" height={18} width={160} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative flex items-center gap-1 px-2 h-12 md:flex-wrap md:gap-3 md:px-3 md:h-11">{t0}{t1}<div className="hidden md:flex md:ml-auto items-center gap-2 shrink-0"><Shimmer className="rounded-md" height={28} width={92} /><Shimmer className="rounded-md" height={28} width={84} /><Shimmer className="rounded-md" height={28} width={28} /></div><Shimmer className="md:hidden shrink-0 rounded-md" height={44} width={44} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <header className="shrink-0 bg-primary border-b border-tertiary/50">{t2}<div className="px-4 pb-2 md:px-3 md:pt-1 md:pb-3.5 flex flex-wrap items-center gap-2"><Shimmer className="rounded-md max-md:hidden" height={20} width={132} /><Shimmer className="rounded-md" height={20} width={56} /><Shimmer className="rounded-md" height={20} width={88} /><Shimmer className="md:hidden ml-auto rounded-md" height={32} width={124} /></div></header>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="shrink-0 px-3 pt-3 pb-2"><Shimmer className="rounded-md" height={32} width="100%" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SidebarSectionSkeleton rows={[78, 64, 70, 56]} withAction={true} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <aside className="hidden md:flex w-64 shrink-0 border-r border-tertiary/50 flex-col">{t4}<div className="flex-1 px-3 pt-2 flex flex-col gap-2">{t5}<SidebarSectionSkeleton rows={[72, 60, 66]} /></div></aside>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="shrink-0 bg-secondary border-b border-tertiary/50"><div className="max-w-(--main-content-max-width) mx-auto w-full px-4 md:px-16 h-12 md:h-11 flex items-center justify-between gap-3"><div className="flex min-w-0 items-center gap-2"><Shimmer className="rounded-sm bg-senary/50" height={16} width={16} /><Shimmer className="rounded-md bg-senary/50" height={18} width={150} /></div><Shimmer className="rounded-md bg-senary/50 max-md:h-8!" height={28} width={104} /></div></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="w-full h-full flex flex-col">{t3}<div className="flex-1 min-h-0 flex overflow-hidden">{t6}<div className="flex-1 min-h-0 flex flex-col overflow-hidden">{t7}<div className="flex-1 min-h-0 overflow-hidden"><div className="max-w-(--main-content-max-width) w-full mx-auto px-4 md:px-16 pt-8 flex flex-col gap-4"><Shimmer className="rounded-lg" height={20} width="40%" /><Shimmer className="rounded-lg" height={120} width="100%" /><Shimmer className="rounded-lg" height={20} width="32%" /><Shimmer className="rounded-lg" height={160} width="100%" /></div></div></div></div></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
};
const SidebarSectionSkeleton = t0 => {
  const $ = _c(12);
  const {
    rows,
    withAction
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-1"><Shimmer className="rounded-sm" height={16} width={16} /><Shimmer className="rounded-md" height={14} width={72} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== withAction) {
    t2 = withAction && <Shimmer className="rounded-sm" height={20} width={20} />;
    $[1] = withAction;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="pr-0.5 h-7 flex items-center justify-between gap-2">{t1}{t2}</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== rows) {
    t4 = rows.map(_temp);
    $[5] = rows;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <ul className="mt-1 mb-0 ml-2.5 pl-3.5 flex flex-col gap-0.5 list-none border-l border-tertiary/50">{t4}</ul>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="flex flex-col gap-1">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default InvestigationLoadingSkeleton;
function _temp(w, i) {
  return <li key={i} className="h-7 px-1.5 flex items-center gap-2"><Shimmer className="rounded-sm" height={16} width={16} /><Shimmer className="rounded-md" height={14} width={w} /></li>;
}